<template>
  <div :class="goNextBtn ? 'message' : ''">
    <div v-show="showPage">
      <div class="li-content">
        <div v-if="access" class="oriModelName">
          <span>投保地区</span>
          <div>
            <p>{{ province }}</p>
            <van-icon name="location-o" size="12" color="#ccc" />
          </div>
        </div>
        <div v-if="!access" class="border-style" @click="areaVisible=true">
          <mt-cell title="选择服务地区" is-link>
            <span>{{ province }}</span>
          </mt-cell>
        </div>
        <div v-if="guangdongArea" class="border-styles">
          <span>销售人员</span>
          <input v-model="salesPerson" type="text" maxlength="30" placeholder="请输入">
        </div>
        <div v-if="guangdongArea" class="border-styles">
          <span>执业证编号</span>
          <input v-model="professionalNum" type="text" maxlength="30" placeholder="请输入">
        </div>
        <div v-if="whethers && accountType === '6'" class="border-style" @click="introducer">
          <mt-cell title="业务归属" is-link>
            <span style="color:rgba(102,102,102,1)">{{ userCode }} {{ userName }}</span>
          </mt-cell>
        </div>
        <div v-if="whethers && accountType === '6' " class="border-style" @click="protocolNumber">
          <mt-cell title="选择协议" is-link>
            <span style="color:rgba(102,102,102,1)">{{ introduceAgreementNo }}</span>
          </mt-cell>
        </div>
        <div v-if="shandongFlag" class="border-style special-font" @click="onlicenseKindCode">
          <mt-cell title="号牌种类" is-link>
            <span style="color:rgba(102,102,102,1)">{{ cardType }}</span>
          </mt-cell>
        </div>
        <div class="plate-number">
          <p :class="shandongFlag ? 'sd-special' : ''">
            车牌号
          </p>
          <div class="car-status-label" :class="noCardNumActive === true ? 'noCardNumActive' : ''" @click="noCardNum">
            未上牌
          </div>
          <input v-model="vehicleInfo.licenseNo" type="text" placeholder="请输入" maxlength="8" @change="licenseNoChange()">
        </div>
        <div v-if="showSwitch">
          <div v-if="isNewCar" class="plate-num">
            <p>是否新车</p>
            <div class="flexjust">
              <van-switch v-model="newCarFalt" size="0.24rem" />
            </div>
          </div>
          <div v-show="showCar">
            <div class="border-style styleflex">
              <span>新车销售公司</span>
              <textarea
                v-model="vehicleInfo.saleCompany"
                class="textareastyle"
                :class="lineheight48"
                placeholder="以商家营业执照为准"
                cols="26"
                rows="1"
                maxlength="30"
              />
            </div>
            <div class="border-style" @click="areaShow=true">
              <mt-cell title="所在地市" is-link>
                <span>{{ vehicleInfo.saleProvinceName }}{{ vehicleInfo.saleAreaName }}</span>
              </mt-cell>
            </div>
            <div class="plate-num">
              <p>是否为4S店</p>
              <div class="flexjust">
                <van-switch v-model="isStore" size="0.24rem" @change="switchChange" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="li-content">
        <div class="border-style">
          <div class="model-head">
            <h3>车辆信息</h3>
            <h4 @click="tellUs=true">
              从哪里看？
            </h4>
            <a @click="estimate">{{ noCardNumActive ? '合格证/行驶证识别' : '行驶证识别' }}</a>
            <img :src="imgAreaUrl" alt="" @click="estimate">
          </div>
        </div>
        <div class="border-style" @click="useMethods">
          <mt-cell title="使用性质" is-link>
            <span style="color:rgba(102,102,102,1)">{{ useMethod }}</span>
          </mt-cell>
        </div>
        <div class="border-style prints">
          <mt-field v-model="vehicleInfo.brandName" label="品牌型号" placeholder="请输入品牌型号" @blur.native.capture="inputChange" />
          <span class="print">打印车型</span>
        </div>
        <div class="border-style position custom">
          <span>您已输入{{ vehicleInfo.vINNo.length }}位！</span>
          <p class="name">
            车架号/VIN码
          </p>
          <input
            v-model="vehicleInfo.vINNo"
            class="input"
            type="text"
            :placeholder="'请输入17位车辆识别代码'"
            maxlength="17"
            @blur="checkDX"
            @change="vINNoChanges"
          >
        </div>
        <div class="border-style">
          <mt-field v-model="vehicleInfo.engineNo" label="发动机号" placeholder="请输入发动机号" @blur.native.capture="inputChange" />
        </div>
        <div class="border-style" @click="ShowRegist">
          <mt-cell :is-link="vehicleInfo.vehicleInfoSource === '1' && shandongFlag ? false : true">
            <template #title>
              <span>注册日期</span>
              <span class="extra-span">初登日期</span>
            </template>
            <span style="color:rgba(102,102,102,1)">{{ vehicleInfo.enrollDate }}</span>
          </mt-cell>
        </div>
        <div class="border-style" @click="ShowAdjust">
          <mt-cell is-link>
            <template #title>
              <span>注册日期调整</span>
              <span class="extra-span">初登日期调整</span>
            </template>
            <span style="color:rgba(102,102,102,1)">{{ vehicleInfo.updateEnrollDate }}</span>
          </mt-cell>
        </div>
        <div class="border-style" @click="ShowIssu">
          <mt-cell title="发证日期" is-link>
            <span style="color:rgba(102,102,102,1)">{{ vehicleInfo.issueDate }}</span>
          </mt-cell>
        </div>
        <div class="oriModelName" @click="goCarList">
          <span>厂牌车型</span>
          <div>
            <p>{{ vehicleInfo.oriModelName }}</p>
            <van-icon name="arrow" size="12" color="#ccc" />
          </div>
        </div>
        <div v-if="shandongFlag" class="border-style">
          <mt-cell title="车辆信息来源">
            <span style="color:rgba(102,102,102,1)">{{
              vehicleInfo.vehicleInfoSource === '1' ? '交管库' : vehicleInfo.vehicleInfoSource === '2' ? '信息库' : ''
            }}</span>
          </mt-cell>
        </div>
        <div v-if="shandongFlag" class="border-style">
          <mt-cell title="交管登记过户日期">
            <span style="color:rgba(102,102,102,1)">{{ vehicleInfo.jGTransferDate }}</span>
          </mt-cell>
        </div>
        <div class="border-style">
          <mt-field
            v-model="vehicleInfo.seatCount"
            label="座位数"
            type="number"
            placeholder="请输入座位数"
            @blur.native.capture="fixScroll"
          />
        </div>
        <div class="border-style">
          <mt-field
            v-model="vehicleInfo.exhaustCapacity"
            label="排量（ml）"
            type="number"
            placeholder="请输入排量"
            @blur.native.capture="fixScroll"
          />
        </div>
        <div class="border-style">
          <mt-field
            v-model="vehicleInfo.power"
            label="功率（kw）"
            type="number"
            placeholder="请输入功率"
            @blur.native.capture="fixScroll"
          />
        </div>
        <div class="border-style">
          <mt-field
            v-model="vehicleInfo.tonCount"
            label="吨位（t）"
            type="number"
            placeholder="请输入吨位"
            @blur.native.capture="fixScroll"
          />
        </div>
        <div class="border-style">
          <mt-field
            v-model="vehicleInfo.completekerbmass"
            label="整备质量（kg）"
            type="number"
            placeholder="请输入整备质量"
            @blur.native.capture="fixScroll"
          />
        </div>
        <div class="border-style">
          <mt-field
            v-model="vehicleInfo.purchasePrice"
            label="新车购置价(￥)"
            type="number"
            placeholder="请输入新车购置价"
            @blur.native.capture="fixScroll"
          />
        </div>
        <div v-if="!shandongFlag" class="border-style" @click="onlicenseKindCode">
          <mt-cell title="号牌种类" is-link>
            <span style="color:rgba(102,102,102,1)">{{ cardType }}</span>
          </mt-cell>
        </div>
        <div class="border-style" @click="onBgColor">
          <mt-cell title="号牌底色" is-link>
            <span style="color:rgba(102,102,102,1)">{{ cardColor }}</span>
          </mt-cell>
        </div>
        <div v-if="HideCarType" class="border-style" @click="onOriCarKindName">
          <mt-cell title="车辆类型" is-link>
            <span style="color:rgba(102,102,102,1)">{{ oriCarKindName }}</span>
          </mt-cell>
        </div>
        <div class="border-style">
          <mt-cell title="是否贷款车">
            <div
              class="yes-no"
              style="border-radius:0.03rem 0 0 0.03rem"
              :class="vehicleInfo.loanVehicleFlag==='0' ? 'active' : ''"
              @click="tranferLoan('0')"
            >
              否
            </div>
            <div
              class="yes-no"
              style="border-radius:0 0.03rem 0.03rem 0"
              :class="vehicleInfo.loanVehicleFlag==='1' ? 'active' : ''"
              @click="tranferLoan('1')"
            >
              是
            </div>
          </mt-cell>
        </div>
        <div class="border-style">
          <mt-cell title="是否过户车">
            <div
              class="yes-no"
              style="border-radius:0.03rem 0 0 0.03rem"
              :style="IsGuohu? 'opacity: 0.4' : ''"
              :class="vehicleInfo.chgOwnerFlag==='0' ? 'active' : ''"
              @click="transferCar('0')"
            >
              否
            </div>
            <div
              class="yes-no"
              style="border-radius:0 0.03rem 0.03rem 0"
              :style="IsGuohu? 'opacity: 0.4' : ''"
              :class="vehicleInfo.chgOwnerFlag==='1' ? 'active' : ''"
              @click="transferCar('1')"
            >
              是
            </div>
          </mt-cell>
        </div>
        <div v-show="vehicleInfo.chgOwnerFlag==='1'" class="border-style" @click="ShowTransfer">
          <mt-cell title="过户登记日期" is-link>
            <span style="color:rgba(102,102,102,1)">{{ transferTime }}</span>
          </mt-cell>
        </div>
        <div v-if="network" class="border-style" @click="open">
          <mt-cell title="网点编码" is-link>
            <span style="color:rgba(102,102,102,1)">{{ vehicleInfo.netWorkName }}</span>
          </mt-cell>
        </div>
        <div v-if="network" class="border-style" @click="searchGroupCar">
          <mt-cell title="团客询价单号" is-link>
            <span style="color:rgba(102,102,102,1)">{{ vehicleInfo.contractNo }}</span>
          </mt-cell>
        </div>
      </div>
      <div v-show="goNextBtn" class="next-step">
        <button @click="goNext">
          下一步
        </button>
      </div>
      <van-popup v-model="isSearchGroupCar" close-on-click-overlay position="bottom" :style="{height: '80%'}" closeable class="group-car">
        <div class="title">
          <div class="line" />
          <div class="title-name">
            请选择团客询价单号
          </div>
        </div>
        <div class="content">
          <div class="search">
            <van-search v-model="searchValue" show-action placeholder="请输入准确完整的单号或名称">
              <template #action>
                <div @click="queryCarList">
                  搜索
                </div>
              </template>
            </van-search>
          </div>
          <div v-if="groupCarList.length > 0" class="list-content">
            <div v-for="(item, index) in groupCarList" :key="index" class="list-item" @click="checkGroup(item, index)">
              <div class="left">
                <img :src="item.active ? modelSrc1 : modelSrc0" alt="">
              </div>
              <div class="right">
                <div class="li-item">
                  <p>团客询价单号</p>
                  <p>{{ item.projectsCode }}</p>
                </div>
                <div class="li-item">
                  <p>团客询价单名称</p>
                  <p>{{ item.inquiryProjectsName }}</p>
                </div>
                <div class="li-item">
                  <p>序号</p>
                  <p>{{ item.serialno }}</p>
                </div>
                <div class="li-item">
                  <p>使用性质</p>
                  <p>{{ item.useNatureName }}</p>
                </div>
                <div class="li-item">
                  <p>车辆类型</p>
                  <p>{{ item.carKindName }}</p>
                </div>
                <div class="li-item">
                  <p>是否单三者</p>
                  <p>{{ item.isSingleThirdName }}</p>
                </div>
                <div class="li-item">
                  <p>备注</p>
                  <p>{{ item.remark }}</p>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="list-content">
            <div class="img-content">
              <img :src="imgEmpty" alt="">
              <p>暂无数据</p>
            </div>
          </div>
        </div>
        <div class="bottom-btn">
          <div class="btn" @click="groupSure">
            确定
          </div>
        </div>
      </van-popup>
      <van-popup v-model="popupVisible" position="bottom" close-on-click-overlay>
        <van-picker :columns="columns" show-toolbar @confirm="onConfirm" @cancel="popupVisible = false" />
      </van-popup>
      <van-popup v-model="searchOption" position="bottom" close-on-click-overlay>
        <van-search v-model="searchTerms" placeholder="请输入搜索关键词" @blur="search($event)" />
        <van-picker
          :columns="columns"
          show-toolbar
          @confirm="onConfirm"
          @cancel="searchOption = false"
        />
      </van-popup>
      <van-popup v-model="tellUs">
        <div class="example">
          <div class="example-content">
            <img alt="" :src="imgUrlExample">
          </div>
          <div class="example-close" @click="tellUs = false">
            关闭
          </div>
        </div>
      </van-popup>
      <van-popup v-model="popupTimeVisible" position="bottom" close-on-click-overlay>
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          :min-date="mDate"
          :max-date="maxDate"
          @confirm="sure"
          @cancel="popupTimeVisible = false"
        />
      </van-popup>
      <van-popup v-model="isShowImg" class="popup-img" @click="isShowImg = false">
        <img alt :src="imgs" style="width:300px;height:200px;">
      </van-popup>
      <van-popup v-model="areaVisible" position="bottom" close-on-click-overlay>
        <van-area
          :area-list="areaList"
          :value="Object.keys(areaList.province_list)[0]"
          :columns-num="2"
          @cancel="areaVisible = false"
          @confirm="sureArea"
        />
      </van-popup>

      <van-popup v-model="areaShow" position="bottom" close-on-click-overlay>
        <van-area
          :area-list="addressList"
          :value="Object.keys(addressList.province_list)[0]"
          :columns-num="2"
          @cancel="areaShow = false"
          @confirm="sureAddress"
        />
      </van-popup>
    </div>
    <ocrIdentinfy
      v-show="!showPage"
      ref="ocrIdentinfy"
      :show-page="showPage"
      :no-card-num-active="noCardNumActive"
      :shandong-flag="shandongFlag"
      :vehicle-info="vehicleInfo"
      @goBack="goBack"
      @newSuccessOcr="newSuccessOcr"
    />
    <Loading :switchs="switchs" />
  </div>
</template>
<script>
import api from '@/api/api.js'
import configure from '@/api/configure.js'
import { Toast, Area, Dialog } from 'vant'
import checkFormat from '@/utils/checkFormat.js'
import Loading from '@/components/Loadings/Loading'
import ocrIdentinfy from '../ocrIdentify/index'
import { vehicleMixin } from './Mixin/mixin'
import { dictionaryType } from '@/utils/const.js'

export default {
  components: {
    'Loading': Loading,
    'ocrIdentinfy': ocrIdentinfy,
    [Area.name]: Area,
    [Dialog.Component.name]: Dialog.Component,
  },
  mixins: [vehicleMixin],
  data() {
    return {
      isSearchGroupCar: false,
      searchValue: '',
      modelSrc1: api.imgAllUrl + '/modelSrc1.png',
      modelSrc0: api.imgAllUrl + '/modelSrc0.png',
      imgEmpty: api.imgAllUrl + '/tixiankong.png',
      IsNewEnergy: false,
      showPage: true,
      showCar: false,
      showSwitch: false,
      lineheight48: 'lineheight48',
      isNewCar: false,
      newCarFalt: false,
      isStore: true,
      currentDate: '',
      searchTerms: '',
      searchOption: false, // 选择器带搜索框的是否显示
      network: false,
      imgobjs: {
        fileId: '',
        fileType: ''
      },
      goNextBtn: true,
      originHeight: '',
      itemFileDataList: {}, // 已暂存的图片
      add: 0, // loading开起的数量
      switchs: false, // loading开关
      register: false, // 发票日期是否显示
      adjust: api.imgAllUrlZSB + '/adjust_79.png', // 注册日期图标
      already: true,
      tipVisibles: false,
      HideCarType: true,
      isShowImg: false,
      imgs: api.imgAllUrl + '/sales140709.png', // 展示的图片
      condition: false, // OCR 识别显示图片
      imgRefresh: api.imgAllUrlZSB + '/yeleiRefresh.png',
      imgAreaUrl: api.imgAllUrl + '/sales290709.png',
      imgUrlCamera: api.imgAllUrl + '/sales140709.png',
      imgUrlExample: api.imgAllUrl + '/sales180709.png',
      popupVisible: false, // 单项选择器
      popupTimeVisible: false, // 日期选择器
      areaVisible: false,
      maxDate: '',
      areaList: {
        province_list: {},
        city_list: {}
      },
      addressList: {
        province_list: {},
        city_list: {}
      },
      areaShow: false,
      comCode: '', // 全员营销登录的归属机构
      userComCode: '', // 登录人的归属机构
      mDate: new Date(2000, 1, 1), // 日期选择器最小显示日期
      transferTimeShow: false, // 显示过户登记日期
      transferTime: '', // 过户登记日期
      tellUs: false, // 从哪里看
      noCardNumActive: false, // 未上牌样式
      province: '', // 投保地区
      city: '', // 市
      useMethod: '家庭自用', // 使用性质
      cardType: '小型汽车号牌',
      cardColor: '蓝色',
      columns: [],
      searchColumn: [],
      vehicleTypeColumn: [], // 车辆类型数组
      LicenseColor: '', // 号牌底色
      LicenseKindCode: '', // 号牌种类
      originPro: '',
      originCity: '',
      oriCarKindName: '轿车', // 车辆类型
      syxClassId: false, // 火车使用性质提示
      areaLists: [], // 省级地区信息
      newCodeCodes: {},
      licenseNos: '',
      acquire: '', // APP获取ocr识别图片
      proposalAreaCode: '',
      proposalCityCode: '',
      conditions: false,
      access: false,
      whether: false,
      processing: false, // 检测是否从订单或续保单进入渲染页面
      datas: {}, // ocr识别后获取的信息
      accountType: null, //  3 业务员，6 远程出单点，7 远程出单点员工，5 c端客户
      userCode: '', // 业务归属
      userName: '', // 业务员名字
      introduceAgreementNo: '', // 代理人协议号
      agreementNoList: [],
      agreementNoFlag: null,
      whethers: false, // 是否是全员营销进入
      content: [], // 业务归属
      channelCode: '',
      guangdongArea: '', // 广东（非深圳）开关
      salesPerson: '', // 销售人员
      professionalNum: '', // 执业证编号
      IsGuohu: false, // true  过户车禁止点击
      shandongFlag: false, // 是否是山东地区
      carOwnerInfo: {
        carOwner: '', // 车主姓名
        ownerAddress: ''// 车主住址
      },
      powerTypeName: '',
      singlePointComeCode: ''
    }
  },
  watch: {
    isNewCar: function(newVal, oldVal) {
      if (newVal && this.newCarFalt) {
        this.showCar = true
      } else {
        this.showCar = false
      }
    },
    newCarFalt: function(newVal, oldVal) {
      if (newVal && this.isNewCar) {
        this.showCar = true
      } else {
        this.showCar = false
      }
    },
    // 'vehicleInfo.brandName': function(newVal, oldVal) {
    //   console.log('brandName')
    //   this.conditions = false
    // },
    // 'vehicleInfo.vINNo': function(newVal, oldVal) {
    //   console.log('vINNo')
    //   this.conditions = false
    // },
    // 'vehicleInfo.engineNo': function(newVal, oldVal) {
    //   console.log('engineNo')
    //   this.conditions = false
    // },
    proposalCityCode: function(newVal, oldVal) {
      if (newVal) {
        this.queryWhetherFeeChangeArea(newVal, this.comCode)
      }
    },
    comCode: function(newVal, oldVal) {
      console.log(newVal, 'newVal')
      if (newVal) {
        this.queryWhetherFeeChangeArea(this.proposalCityCode, newVal)
      }
    },
    vehicleInfo: {
      deep: true,
      handler(newVal, oldVal) {
        if (this.processing) {
          this.processing = false
        } else {
          if (this.$store.state.page === '1') {
            this.$store.commit('setAlter', '1')
          }
        }
        this.lineheight48 = newVal.saleCompany.length > 12 ? '' : 'lineheight48'
        this.vehicleInfo.licenseNo = newVal.licenseNo.toUpperCase()
        this.vehicleInfo.engineNo = newVal.engineNo.toUpperCase()
        this.vehicleInfo.vINNo = newVal.vINNo.toUpperCase()
      }
    },
    add(value) {
      value > 0 ? this.switchs = true : this.switchs = false
    },
    // 2021-6-28  新增过户车规则
    /*
    1、发证日期在365天内（含），且“发证日期”不等于“注册日期”，则自动打开“是否过户车”按钮，允许用户手动修改
    2、报价时获取平台返回的过户车类型
      2.1  若平台返回为“过户车”，且发证日期在365天内（含），则自动打开“是否过户车”按钮，不允许用户手动修改
      2.2  若平台返回为“过户车”，且发证日期在365天外，则以“基础信息页面”的信息为准（第一步选的是就是，非就非）
      2.3  若平台返回为“非过户车”，则以“基础信息页”的信息为准（第一步选的是就是，非就非）
    */
    'vehicleInfo.enrollDate': function(newVal, oldVal) {
      if (this.vehicleInfo.issueDate) {
        const enrollDateStr = new Date(newVal).getTime()
        const issueDateStr = new Date(this.vehicleInfo.issueDate).getTime()
        const yearFlag = this.getDateChange(this.vehicleInfo.issueDate)
        if (yearFlag && Number(enrollDateStr) !== Number(issueDateStr)) {
          this.transferCar('1')
        }
      }
    },
    'vehicleInfo.issueDate': function(newVal, oldVal) {
      if (this.vehicleInfo.enrollDate) {
        const enrollDateStr = new Date(this.vehicleInfo.enrollDate).getTime()
        const issueDateStr = new Date(newVal).getTime()
        const yearFlag = this.getDateChange(newVal)
        if (yearFlag && Number(enrollDateStr) !== Number(issueDateStr)) {
          this.transferCar('1')
        }
      }
    },
    '$store.state.guohuFlag': function(newVal, oldVal) {
      this.IsGuohu = newVal
    }
  },
  mounted() {
    function onBridgeReady() {
      WeixinJSBridge.call('hideOptionMenu')
    }
    if (typeof WeixinJSBridge === 'undefined') {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
        document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
      }
    } else {
      onBridgeReady()
    }
    this.IsGuohu = this.$store.state.guohuFlag
    this.getConfigList()
    this.clearStore()
    const UserInfo = JSON.parse(localStorage.getItem('setPersonUserInfo'))
    if (UserInfo && localStorage.getItem('setChannelCode') === configure.ZKICATMChannelCode) {
      this.dispose(UserInfo)
    }
    if (UserInfo) {
      if (UserInfo.accountType === '3') {
        this.salesPerson = UserInfo.salesmanInfoDto.userName
        this.professionalNum = UserInfo.salesmanInfoDto.professionalNum
      }
      this.access = true
      this.$http.get(api.getUpProvinceCom).then(res => {
        this.province = res.data[0].codeName
        this.proposalAreaCode = res.data[0].newCodeCode
        this.comCode = res.data[0].codeCode
        this.$store.commit('setComCode', this.comCode)
        this.queryVehicleType(this.comCode)
        if (this.proposalAreaCode.startsWith('440') && !this.proposalAreaCode.startsWith('4403')) {
          this.isNewCar = true
          this.guangdongArea = true
        } else if (this.comCode.startsWith('237')) {
          // 山东地区标志
          this.isNewCar = false
          this.shandongFlag = true
        } else {
          this.isNewCar = false
          this.guangdongArea = false
        }
      }).catch(error => {
        console.log(error)
      })
    }
    if (this.$route.query.Mark) {
      this.$store.commit('setMark', true)
    }

    this.channelCode = localStorage.getItem('setChannelCode')
    if (localStorage.getItem('setChannelCode') === configure.ZKICATMChannelCode) {
      this.network = true
    }
    // 续保信息逻辑
    const carMessage = JSON.parse(localStorage.getItem('setCarMessage'))
    if (carMessage) {
      if (carMessage.rtnCode && carMessage.rtnCode === '0000') {
        if (carMessage.plateNo) {
          this.vehicleInfo.licenseNo = decodeURIComponent(carMessage.plateNo)
        }
        if (carMessage.engineNo) {
          this.vehicleInfo.engineNo = carMessage.engineNo
        }
        if (carMessage.vin) {
          this.vehicleInfo.vINNo = carMessage.vin
          this.previous(2)
        }
        if (carMessage.model) {
          this.vehicleInfo.brandName = decodeURIComponent(carMessage.model)
        }
        if (carMessage.registerDate) {
          this.vehicleInfo.enrollDate = carMessage.registerDate
          this.vehicleInfo.certificateDate = carMessage.registerDate
          this.vehicleInfo.updateEnrollDate = carMessage.registerDate
        }
        if (carMessage.issueDate) {
          this.vehicleInfo.issueDate = carMessage.issueDate
        }
        if (carMessage.fileId) {
          this.imgobjs = {
            fileId: carMessage.fileId,
            fileType: '2'
          }
        }
      }
    }
    const orderId = localStorage.getItem('setOrderId')
    configure.allChannelCode.indexOf(localStorage.getItem('setChannelCode')) > -1 ? this.getUpProvinceCom() : this.getProvinceAndCity()
    this.searchs('')
    if (!checkFormat.isEmpty(orderId)) {
      this.add += 1
      this.$store.commit('setOrderId', orderId)
      this.$http.post(api.queryOrderDetail + '?orderId=' + orderId + '&fileContentFlag=0')
        .then((res) => {
          this.add = this.add - 1
          if (res.data.rtnCode === '0000') {
            this.conditions = true
            this.whether = true
            this.information(res.data.resultObj, 0)
          } else {
            Toast(res.data.rtnMsg)
          }
        })
        .catch(error => {
          this.add = this.add - 1
          console.log(error)
        })
    }
    if (localStorage.getItem('setPolicyNo')) {
      this.$http.get(api.fastRenewal + '?orderOrigin=' + localStorage.getItem('setChannelCode') + '&policyNo=' + localStorage.getItem('setPolicyNo')).then(res => {
        if (res.data.rtnCode === '0000' || res.data.rtnCode === '1097') {
          this.information(res.data, 3)
          this.$store.commit('setParams', res.data)
        }
      }).catch(error => {
        console.log(error)
      })
    }
    this.dictionary()
  },
  activated() {
    if (this.$store.state.label) {
      this.add += 1
      this.information(this.$store.state.total, 3)
      this.add = this.add - 1
    }
    this.originHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0
    if (checkFormat.getPhoneLike() === 'ANDROID') {
      window.addEventListener('resize', this.resizeFn)
    }
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    this.$store.commit('setStep', '1')// 这句不能删！！
    this.$store.commit('setShow', true)
    this.returnData = this.$route.params
    if (this.returnData.result !== undefined) {
      this.conditions = true
      if (!checkFormat.isEmpty(this.returnData.result.oriCarKindName)) {
        this.vehicleInfo.oriCarKindName = this.returnData.result.oriCarKindName
        this.getVehicletype(this.vehicleInfo.oriCarKindName)
      } else {
        this.getVehicletype(this.vehicleInfo.oriCarKindName)
      }
      if (this.vehicleInfo.newCodeCode === '320000' && this.returnData.result.licenseNo !== '') {
        this.vehicleInfo.licenseNo = this.returnData.result.licenseNo
      }
      this.vehicleInfo.seatCount = this.returnData.result.seatCount
      this.vehicleInfo.modelEnergyType = this.returnData.result.power_Type_Code
      this.powerTypeName = this.returnData.result.power_Type
      if (this.returnData.result.exhaustCapacity === '') {
        this.vehicleInfo.exhaustCapacity = '0'
      } else {
        this.vehicleInfo.exhaustCapacity = this.returnData.result.exhaustCapacity
      }
      if (this.returnData.result.vehicleTonnage === null || this.returnData.result.vehicleTonnage === '') {
        this.vehicleInfo.tonCount = '0'
      } else {
        this.vehicleInfo.tonCount = this.returnData.result.vehicleTonnage / 1000
      }
      checkFormat.isEmpty(this.returnData.result.vehicleWeight) ? this.vehicleInfo.completekerbmass = '0' : this.vehicleInfo.completekerbmass = this.returnData.result.vehicleWeight
      if (this.returnData.result.syxClassId === 'KA' || this.returnData.result.syxClassId === 'KB' || this.returnData.result.syxClassId === 'KC' || this.returnData.result.syxClassId === 'KD' || this.returnData.result.syxClassId === 'KE') {
        this.vehicleInfo.carKindCode = 'A0'
        this.syxClassId = false
      } else if (this.returnData.result.syxClassId === 'HA' || this.returnData.result.syxClassId === 'HB' || this.returnData.result.syxClassId === 'HC' || this.returnData.result.syxClassId === 'HD') {
        this.vehicleInfo.carKindCode = 'H0'
        this.syxClassId = true
      } else if (this.returnData.result.syxClassId === 'NA') {
        this.vehicleInfo.carKindCode = 'H1'
        this.syxClassId = true
      }
      this.vehicleInfo.purchasePrice = (this.returnData.result.productStatus === '停产' && Number(this.returnData.result.kindredPrice) > 0) ? this.returnData.result.kindredPrice : this.returnData.result.purchasePrice
      this.vehicleInfo.oriModelName = this.returnData.result.modelName
      this.vehicleInfo.platVehicleCode = this.returnData.result.platVehicleCode
      this.vehicleInfo.vehicleId = this.returnData.result.vehicleId
      this.vehicleInfo.importFlag = this.returnData.result.importFlag
      this.vehicleInfo.power = this.returnData.result.power
    }
  },
  deactivated() {
    window.removeEventListener('resize', this.resizeFn)
    this.goNextBtn = true
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeFn)
    this.goNextBtn = true
  },
  methods: {
    goBack() {
      this.$store.commit('setShow', true)
      this.showPage = true
      this.goNextBtn = true
    },
    fixScroll() {},
    getDateChange(value) {
      const nowDate = new Date().getTime()
      const isssuStr = new Date(value).getTime()
      return nowDate - isssuStr <= 60 * 60 * 24 * 365 * 1000
    },
    getConfigList() {
      this.$http.post(api.getConfigList, { configType: '紫属保' }).then(res => {
        if (res.data.rtnCode === '0000') {
          res.data.configList.forEach(item => {
            if (item.configCode === 'RENEW_FLAG') {
              this.showSwitch = item.configValue === '1'
            }
          })
        }
      }).catch(error => {
        console.log(error)
      })
    },
    switchChange(value) {
      this.vehicleInfo.sale4SFlag = value ? 1 : 0
    },
    // 交管是否开启codecname 0开启 否则是关闭
    queryTrafficControl() {
      this.$http.post(api.getCodeType, { codeCode: '1000', codeLevel: '', codeType: 'JiangSuTraffic', upperCode: '' }).then(res => {
        if (res.data.rtnCode === '0000') {
          this.HideCarType = res.data.result[0].codecname !== '0'
        }
      }).catch(error => {
        console.log(error)
      })
    },
    dispose(UserInfo) {
      this.whethers = true
      this.comCode = UserInfo.salesmanInfoDto.comCode
      this.userComCode = UserInfo.salesmanInfoDto.comCode
      this.accountType = UserInfo.accountType
      if (this.accountType === '3' || this.accountType === '7' || (localStorage.getItem('setOrderId') && !this.accountType)) {
        this.userCode = UserInfo.salesmanInfoDto.userCode
        this.userName = UserInfo.salesmanInfoDto.userName
        localStorage.setItem('setSalesCode', this.userCode)
      } else if (this.$route.query.share) {
        this.userCode = localStorage.getItem('setSalesCode')
        this.userName = localStorage.getItem('setSalesName')
      }
      this.agreementNoFlag = UserInfo.agreementNoFlag
      this.agreementNoList = UserInfo.agreementNoList
    },
    searchs(value) {
      this.add += 1
      let userCodes = ''
      let userNames = ''
      if (value) {
        const reg = /^[\u2E80-\u9FFF]+$/
        reg.test(value) ? userNames = value : userCodes = value
      }
      this.$http.get(`${api.getUpComCode}?comCode=${this.comCode}`).then(async res => {
        const inParameter = {
          pageNum: 0,
          pageSize: 100,
          comCode: res.data,
          status: '1',
          userCode: userCodes,
          userName: userNames
        }
        await this.$http.post(api.SalesList, inParameter).then(salesRes => {
          if (salesRes.data.code === '0000') {
            this.content = salesRes.data.data.content
            this.columns = []
            this.content.forEach(item => {
              const obj = {
                text: item.userCode + '  ' + item.name,
                code: item.userCode,
                name: item.name,
                comCode: item.teamCode
              }
              this.columns.push(obj)
            })
          } else {
            this.$toast(res.data.message)
          }
          this.add = this.add - 1
        }).catch(err => {
          console.log(err)
          this.add = this.add - 1
        })
      }).catch(error => {
        console.log(error)
        this.add = this.add - 1
      })
    },
    resizeFn() {
      const resizeHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0
      this.goNextBtn = this.originHeight - 0 <= resizeHeight - 0
    },
    estimate() {
      this.$store.commit('setShow', false)
      this.showPage = false
      this.goNextBtn = false
    },
    getVehicletype(val) {
      this.add += 1
      this.$http.post(api.getByMoreCodeType, [{ codeType: 'VehicleType' }]).then(res => {
        this.add = this.add - 1
        if (res.data.rtnCode === '0000') {
          res.data.result.forEach(value => {
            if (value.codeCode === val) {
              this.oriCarKindName = value.codecname
            }
          })
        }
      }).catch(error => {
        this.add = this.add - 1
        console.log(error)
      })
    },
    // 车辆使用性质选择器打开
    useMethods() {
      this.popupVisible = true
      this.status = 'useMethod'
      this.columns = []
      this.data.forEach(item => {
        if (item.codeType === 'UseNature') {
          const obj = {
            text: item.codecname,
            code: item.codeCode
          }
          this.columns.push(obj)
        }
      })
      for (const i in this.columns) {
        if (this.vehicleInfo.useNatureCode === this.columns[i].code) {
          this.columns.defaultIndex = Number(i)
        }
      }
    },
    introducer() {
      if (this.accountType !== '3') {
        this.searchOption = true
        this.status = 'introducer'
        this.columns = []
        this.content.forEach(item => {
          const obj = {
            text: item.userCode + '  ' + item.name,
            code: item.userCode,
            name: item.name
          }
          this.columns.push(obj)
        })
      }
    },
    protocolNumber() {
      this.popupVisible = true
      this.status = 'agreementNoList'
      this.columns = []
      this.agreementNoList.forEach(item => {
        const obj = {
          text: item,
          code: item
        }
        this.columns.push(obj)
      })
      for (const i in this.columns) {
        if (this.userCode === this.columns[i].code) {
          this.columns.introduceAgreementNo = Number(i)
        }
      }
    },
    // 确认销售公司所在地
    sureAddress(value) {
      this.areaShow = false
      this.vehicleInfo.saleProvinceName = value[0].name
      this.vehicleInfo.saleAreaName = value[1].name
      this.vehicleInfo.saleProvinceCode = value[0].code
      this.vehicleInfo.saleAreaCode = value[1].code
    },
    queryVehicleType(comCode) {
      const params = {
        codeType: 'VehicleType',
        comCode: comCode
      }
      this.$http.post(api.queryVehicleType, params).then(res => {
        this.vehicleTypeColumn = res.data
      }).catch(error => {
        console.log(error)
      })
    },
    // 数据字典
    dictionary() {
      this.add += 1
      this.$http.post(api.getByMoreCodeType, dictionaryType)
        .then(res => {
          this.add = this.add - 1
          if (res.data.rtnCode === '0000') {
            this.data = res.data.result
          } else {
            Toast(res.data.rtnMsg)
          }
        })
        .catch(error => {
          this.add = this.add - 1
          console.log(error)
        })
    },
    licenseNoChange() {
      // 山东地区触发交管库查询
      if (this.shandongFlag && this.vehicleInfo.licenseNo) {
        this.queryVehicleInfoInSd(this.vehicleInfo.licenseNo, this.vehicleInfo.vINNo, this.vehicleInfo.licenseKindCode || '02')
      }
    },
    vINNoChanges() {
      this.conditions = false
      // 山东地区触发交管库查询
      if (this.shandongFlag && this.vehicleInfo.vINNo) {
        this.queryVehicleInfoInSd(this.vehicleInfo.licenseNo, this.vehicleInfo.vINNo, this.vehicleInfo.licenseKindCode || '02')
      }
    },
    // 号牌种类
    onlicenseKindCode() {
      this.popupVisible = true
      this.status = 'LicenseKindCode'
      this.columns = []
      this.data.forEach(item => {
        if (item.codeType === 'LicenseKindCode') {
          const obj = {
            text: item.codecname,
            code: item.codeCode
          }
          this.columns.push(obj)
        }
      })
      for (const i in this.columns) {
        if (this.vehicleInfo.licenseKindCode === this.columns[i].code) {
          this.columns.defaultIndex = Number(i)
        }
      }
    },
    // 车辆类型
    onOriCarKindName() {
      if (this.vehicleTypeColumn.length > 0) {
        this.searchOption = true
        this.status = 'VehicleType'
        this.columns = []
        this.vehicleTypeColumn.forEach(item => {
          const obj = {
            text: item.codeCode + '-' + item.codecname,
            code: item.codeCode
          }
          this.columns.push(obj)
          this.searchColumn.push(obj)
        })
        for (const i in this.columns) {
          if (this.vehicleInfo.oriCarKindName === this.columns[i].code) {
            this.columns.defaultIndex = Number(i)
          }
        }
      } else {
        Toast('请选择服务地区')
      }
    },
    // 号牌底色
    onBgColor() {
      this.popupVisible = true
      this.status = 'LicenseColor'
      this.columns = []
      this.data.forEach(item => {
        if (item.codeType === 'LicenseColor') {
          const obj = {
            text: item.codecname,
            code: item.codeCode
          }
          this.columns.push(obj)
        }
      })
      for (const i in this.columns) {
        if (this.vehicleInfo.licenseColorCode === this.columns[i].code) {
          this.columns.defaultIndex = Number(i)
        }
      }
    },
    // 查询投保地区
    getUpProvinceCom() {
      this.add += 1
      // 调数据字典
      const provParam = {
        codeType: 'DisTrictCode',
        codeLevel: '2'
      }
      this.$http.post(api.getByCodeType, provParam)
        .then(res => {
          const resProvData = res.data
          for (const i in resProvData) {
            this.add += 1
            this.areaLists.push(resProvData[i])
            this.areaList.province_list[resProvData[i].codeCode] = resProvData[i].codecname
            this.addressList.province_list[resProvData[i].codeCode] = resProvData[i].codecname
            const cityParams = {
              codeType: 'DisTrictCode',
              upperCode: resProvData[i].codeCode,
              codelevel: '3'
            }
            this.$http.post(api.getByCodeTypeAndUpperCode, cityParams)
              .then(resCity => {
                this.add = this.add - 1
                const resCityData = resCity.data
                for (const k in resCityData) {
                  this.areaList.city_list[resCityData[k].codeCode] = resCityData[k].codecname
                  this.addressList.city_list[resCityData[k].codeCode] = resCityData[k].codecname
                  this.newCodeCodes[resCityData[k].codeCode] = resCityData[k].newCodeCode
                }
              })
              .catch(error => {
                this.add = this.add - 1
                console.log(error)
              })
          }
          this.add = this.add - 1
        })
        .catch(error => {
          this.add = this.add - 1
          console.log(error)
        })
    },
    getProvinceAndCity() {
      this.add += 1
      // 调数据字典
      const provParam = {
        codeCode: '',
        codeLevel: 2,
        codeType: 'ChannelProvinceCity',
        systemCode: localStorage.getItem('setChannelCode'),
        upperCode: ''
      }
      this.$http.post(api.queryStandardByCodeTypeAndSystemCode, provParam)
        .then(res => {
          const resProvData = res.data
          for (const i in resProvData) {
            this.add += 1
            this.areaLists.push(resProvData[i])
            this.areaList.province_list[resProvData[i].codeCode] = resProvData[i].codecname
            const cityParams = {
              codeType: 'ChannelProvinceCity',
              upperCode: resProvData[i].codeCode,
              codelevel: '3',
              systemCode: localStorage.getItem('setChannelCode'),
              codeCode: ''
            }
            this.$http.post(api.queryStandardByCodeTypeAndUpperCodeAndSystemCode, cityParams)
              .then(resCity => {
                this.add = this.add - 1
                const resCityData = resCity.data
                for (const k in resCityData) {
                  this.areaList.city_list[resCityData[k].codeCode] = resCityData[k].codecname
                  this.newCodeCodes[resCityData[k].codeCode] = resCityData[k].newCodeCode
                }
              })
              .catch(error => {
                this.add = this.add - 1
                console.log(error)
              })
          }
          this.add = this.add - 1
        })
        .catch(error => {
          this.add = this.add - 1
          console.log(error)
        })
    },
    // 未上牌
    noCardNum() {
      this.noCardNumActive = !this.noCardNumActive
      this.vehicleInfo.noLicenseFlag = this.noCardNumActive ? '0' : '1'
    },
    getNature(val) {
      this.add += 1
      this.$http.post(api.getByMoreCodeType, [{ codeType: 'UseNature' }]).then(res => {
        this.add = this.add - 1
        if (res.data.rtnCode === '0000') {
          res.data.result.forEach(value => {
            if (value.codeCode === val) {
              this.useMethod = value.codecname
            }
          })
        }
      })
        .catch(error => {
          this.add = this.add - 1
          console.log(error)
        })
    },
    // 续保接口
    previous(load) {
      if (!this.whether) {
        const data = {
          channelCode: this.channelCode,
          licenseNo: '',
          vinNo: this.vehicleInfo.vINNo,
          carOwner: '',
          queryFlag: 1
        }
        this.add += 1
        this.$http.post(api.getLastYearPolicy, data)
          .then(res => {
            if (res.data.rtnCode === '0000') {
              this.information(res.data, load)
            } else {
              this.getVehicleInfo()
            }
            this.add = this.add - 1
          })
          .catch(error => {
            console.log(error)
            this.getVehicleInfo()
            this.add = this.add - 1
          })
      }
    },
    // 车辆预填服务
    getVehicleInfo() {
      if (this.carOwnerInfo.carOwner && this.carOwnerInfo.ownerAddress) {
        this.$store.commit('setCarOwnerInfo', this.carOwnerInfo)
      }
      const params = {
        'baseInfo': {
          'channelCode': this.channelCode,
          'introduceCode': this.userCode
        },
        'channelCode': this.channelCode,
        'vINNo': this.vehicleInfo.vINNo,
        'proposalAreaCode': this.proposalAreaCode,
        'proposalCityCode': this.proposalCityCode
      }
      this.$http.post(api.queryVehicleInfo, params)
        .then(res => {
          const resData = res.data
          if (resData.rtnCode === '0000') {
            if (!checkFormat.isEmpty(resData.vehicleBasePart)) {
              this.vehicleInfo.brandName = resData.vehicleBasePart.brandName
              this.vehicleInfo.engineNo = resData.vehicleBasePart.engineNo
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    // VIN转大写
    checkDX() {
      this.previous(1)
    },
    // 注册日期
    ShowRegist() {
      if (this.vehicleInfo.vehicleInfoSource === '1' && this.shandongFlag) {
        return false
      }
      this.maxDate = new Date()
      this.currentDate = new Date(this.vehicleInfo.enrollDate)
      this.popupTimeVisible = true
      this.status = 'ShowRegist'
    },
    // 注册日期调整
    ShowAdjust() {
      this.maxDate = new Date()
      this.currentDate = new Date(this.vehicleInfo.updateEnrollDate)
      this.popupTimeVisible = true
      this.status = 'ShowAdjust'
    },
    ShowIssu() {
      this.maxDate = new Date()
      this.currentDate = new Date(this.vehicleInfo.issueDate)
      this.popupTimeVisible = true
      this.status = 'ShowIssu'
    },
    // 过户日期
    ShowTransfer() {
      this.maxDate = new Date()
      this.currentDate = new Date(this.transferTime)
      this.popupTimeVisible = true
      this.status = 'ShowTransfer'
    },
    search(e) {
      if (this.status === 'introducer') {
        this.searchs(this.searchTerms)
      } else if (this.status === 'VehicleType') {
        let filterText = e ? e.trim() : ''
        filterText = filterText.toUpperCase()
        if (filterText === '') {
          this.columns = this.searchColumn
        } else {
          this.columns = this.searchColumn.filter(item => item.text.toUpperCase().indexOf(filterText) !== -1)
        }
      }
    },
    // 确认单项选择器
    onConfirm(value) {
      if (this.status === 'introducer') {
        this.userCode = value.code
        this.userName = value.name
        this.singlePointComeCode = value.comCode
        this.searchOption = false
      }
      if (this.status === 'agreementNoList') {
        this.introduceAgreementNo = value.text
      }
      if (this.status === 'useMethod') {
        this.useMethod = value.text
        this.vehicleInfo.useNatureCode = value.code
      }
      if (this.status === 'netWork') {
        this.vehicleInfo.netWorkCode = value.code
        this.vehicleInfo.netWorkName = value.text
      }
      if (this.status === 'LicenseKindCode') {
        this.vehicleInfo.licenseKindCode = value.code
        this.cardType = value.text
      }
      if (this.status === 'LicenseColor') {
        this.vehicleInfo.licenseColorCode = value.code
        this.cardColor = value.text
      }
      if (this.status === 'VehicleType') {
        // 因为车辆类型选项里面的text是   code-text 的格式，所以需要拆分一下。
        const tmpText = value.text ? value.text : ''
        const tmpTextArr = tmpText.split('-')
        this.oriCarKindName = tmpTextArr[tmpTextArr.length - 1]
        this.vehicleInfo.oriCarKindName = value.code
        this.searchOption = false
      }
      if (this.status === 'fuelType') {
        this.fuelTypeName = value.text
        this.vehicleInfo.fuelType = value.code
      }
      this.popupVisible = false
    },
    // 确认日期选择器
    sure(value, status) {
      if (status) {
        this.status = status
      }
      if (this.status === 'ShowRegist') {
        this.vehicleInfo.enrollDate = checkFormat.getTimeToDate(value)
        this.vehicleInfo.certificateDate = checkFormat.getTimeToDate(value)
        this.vehicleInfo.updateEnrollDate = checkFormat.getTimeToDate(value)
      } else if (this.status === 'ShowTicket') {
        this.vehicleInfo.certificateDate = checkFormat.getTimeToDate(value)
      } else if (this.status === 'ShowTransfer') {
        this.transferTime = checkFormat.getTimeToDate(value)
        this.vehicleInfo.makeDate = checkFormat.getTimeToDate(value)
      } else if (this.status === 'ShowAdjust') {
        this.vehicleInfo.updateEnrollDate = checkFormat.getTimeToDate(value)
      } else if (this.status === 'ShowIssu') {
        this.vehicleInfo.issueDate = checkFormat.getTimeToDate(value)
      }
      this.popupTimeVisible = false
    },
    // 是否过户车
    transferCar(param) {
      // 需要识别报价页面报价所返回得是否过户车的标志
      if (!this.IsGuohu) {
        this.vehicleInfo.chgOwnerFlag = param
        this.transferTimeShow = param === '1'
        if (this.vehicleInfo.chgOwnerFlag === '0') {
          this.transferTime = ''
          this.vehicleInfo.makeDate = ''
        }
      } else {
        this.vehicleInfo.chgOwnerFlag = this.$store.state.vehicleInfo.chgOwnerFlag
        if (this.vehicleInfo.chgOwnerFlag === '0') {
          this.transferTime = ''
          this.vehicleInfo.makeDate = ''
        }
      }
    },
    tranferLoan(param) {
      this.vehicleInfo.loanVehicleFlag = param
    },
    HideType(val) {
      const jiangsu = /^[2][3][2]/ // 江苏
      const guangdong = /^[2][4][4]/ // 广东
      if (jiangsu.test(val)) {
        this.queryTrafficControl()
      } else if (guangdong.test(val)) {
        this.HideCarType = /^[2][4][4][0][3]/.test(val)
      } else {
        this.HideCarType = true
      }
    },
    queryWhetherFeeChangeArea(value, comCodeValue) {
      const param = {
        cityCode: value,
        comCode: comCodeValue
      }
      this.$http.post(api.queryWhetherFeeChangeArea, param).then(res => {
        if (res.data.rtnCode === '0000') {
          localStorage.setItem('whetherFeeChangeArea', res.data.whetherFeeChangeArea)
        }
      })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./message.scss";

</style>




// WEBPACK FOOTER //
// src/pages/car/vehicle/index.vue